<template>
    <div id="res-dialog" class="dialog" style="display: none">
        <div class="dialog__container mdc-elevation--z2">
            <div role="progressbar" id="res-dialog-progress" class="mdc-linear-progress mdc-linear-progress--indeterminate mdc-linear-progress--closed" data-mdc-auto-init="MDCLinearProgress">
                <div class="mdc-linear-progress__buffering-dots"></div>
                <div class="mdc-linear-progress__buffer"></div>
                <div class="mdc-linear-progress__bar mdc-linear-progress__primary-bar">
                    <span class="mdc-linear-progress__bar-inner"></span>
                </div>
                <div class="mdc-linear-progress__bar mdc-linear-progress__secondary-bar">
                    <span class="mdc-linear-progress__bar-inner"></span>
                </div>
            </div>

            <div id="store-box" class="section-box center" v-show="showOne">
                <span class="header">選擇分店</span>
                <div id="container-store" class="dialog__container--horizontal-box">
                    <div v-for="(result, index) in this.mutableStores" class="store-item mdc-elevation--z1" :data-id="result.id" v-on:click.prevent="onStoreClick($event, result)">
                        <span class="item__title">{{ result.mall.name }}</span>
                    </div>
                </div>
            </div>

            <div id="table-box" class="section-box center" v-show="tables.length">
                <span class="header">選項</span>
                <div id="container-table" class="dialog__container--horizontal-box">
                    <div v-for="(result, index) in this.tables" class="table-item mdc-elevation--z1" :data-id="result.id" v-on:click.prevent="onTableClick($event, result)">
                        <span class="item__title">{{ result.name }}</span>
                    </div>
                </div>
            </div>

            <div id="date-box" class="section-box">
                <span v-show="this.dates.length" class="header">日期</span>
                <div v-show="this.dates.length" id="container-date" class="dialog__container--horizontal-box">
                    <div v-for="result in this.dates" class="date-item  mdc-elevation--z1" data-key="date" v-on:click.prevent="onDateClick($event, result)">
                        <span class="item__title">{{ result.date_format }}<br/>{{ result.weekday }}</span>
                        <span v-if="sumDiscount(result)" class="discount">
                            <span class="percentage">
                                {{ sumDiscount(result) }}
                            </span>
                        </span>
                    </div>
                </div>
            </div>

            <div id="time-box" class="section-box">
                <span v-show="this.times.length" class="header">時間</span>
                <div v-show="this.times.length" id="container-time" class="dialog__container--horizontal-box">
                    <div v-for="result in this.times" v-show="!result.hidden" class="time-item mdc-elevation--z1" :class="{'time-slot_arrow-right' : result.max_stay_hour > 1}" data-key="time" v-on:click.prevent.stop="onTimeClick($event, result)">
                        <span class="item__title">{{ result.start }} {{ result.end_at ? `- ${result.end_at}` : ''}}</span>
                        <span class="item__icon--tail material-icons" v-if="result.max_stay_hour > 1">arrow_drop_down</span>
                        <span v-if="result.time_discount" class="discount">
                            <span class="percentage">
                                {{ toChineseDiscount(result.time_discount) }}
                            </span>
                        </span>
                    </div>
                </div>
            </div>

            <div id="person-box" class="section-box" v-if="max_customer.length">
                <span v-show="this.max_customer.length > 0" class="header">人數</span>
                <div v-show="this.max_customer.length > 0" id="container-customer" class="dialog__container--horizontal-box">
                    <div v-for="n in this.max_customer" class="person-item mdc-elevation--z1" data-key="max_customer" v-on:click.prevent="onPersonClick($event, n)">
                        <span class="item__title">{{ n.number }}人</span>
                        <span v-if="n.discount" class="discount">
                            <span class="percentage">
                                {{ toChineseDiscount(n.discount) }}
                            </span>
                        </span>
                    </div>
                </div>
            </div>

            <div v-else-if="this.times.length && this.max_customer.length <= 0" class="section-box">
                <span class="header">人數</span>
                <div class="dialog__container--horizontal-box">
                    <div class="person-item mdc-elevation--z1" data-key="max_customer">
                        <span class="item__title">你所選擇的時間沒有空位 或 該點已經打烊了</span>
                    </div>
                </div>
            </div>

            <div class="res-divider"></div>

            <div id="button-box" class="section-box" v-if="showSubmit">
                <div class="dialog__container--action">
                    <span class="total-discount" v-if="discount.haveDiscount()">{{ toChineseDiscount(this.discount.total()) }}</span>
                    <div v-else style="border-top: 2px var(--mdc-theme-primary) solid; width: 100%;"></div>
                    <button id="submit" type="button" class="reserve-submit mdc-button mdc-button--raised" v-on:click.prevent="submit">
                        <span class="mdc-button__label">立即預約</span>
                    </button>
                </div>
            </div>
            <button class="close material-icons" type="button" v-on:click.prevent="close">close</button>
        </div>

        <div class="mdc-menu-backdrop" v-show="shownMenu">
            <div id="time-to-stay-option" class="mdc-menu mdc-menu-surface" data-mdc-auto-init="MDCMenu">
                <ul class="mdc-list" role="menu" aria-hidden="true" aria-orientation="vertical" tabindex="-1">
                    <li class="mdc-list-item" role="menuitem" v-for="n in stay_hour" :data-value="n - 1" v-on:click.prevent="onStayTimeClick($event, n)">
                        <span class="mdc-list-item__text">預約{{n}}小時</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            stores: {
                type: Array,
                default() {
                    return [];
                },
            }
        },
        data: function() {
            return {
                showMenu: true,
                showOne: true,
                shownMenu: null,
                showSubmit: false,
                mutableStores: this.stores,
                selectedStore: null,
                discount: {
                    date: 1,
                    weekday: 1,
                    time: 1,
                    person: 1,

                    haveDiscount: function () {
                        return this.date < 1  || this.time < 1 || this.person < 1|| this.weekday < 1;
                    },

                    total: function () {
                        return ((1 - this.date * this.time * this.person * this.weekday) * 100).toFixed(2);
                    },

                    reset() {
                        this.person = 1;
                        this.date = 1;
                        this.weekday = 1;
                        this.time = 1;
                    }
                },
                tables:[],
                dates: [],
                times: [],
                selectedTimeSlot: null,
                max_customer : [],
                stay_hour: 0,
                form: new FormData(),
                progressBar: new window.mdc.linearProgress.MDCLinearProgress($('.mdc-linear-progress')[0]),
            }
        },
        methods: {
            formValidator: function() {
                return !(!this.form.has('start_at') ||
                    !this.form.has('end_at') ||
                    !this.form.has('date') ||
                    !this.form.has('max_customer') ||
                    !this.form.has('store_id') ||
                    !this.form.has('table_id'));
            },
            isTimeFull($item) {
                let fulls = $item['times'].map(function (object, index) {
                    return object.hasOwnProperty('is_full');
                });
                return !fulls.includes(false);
            },
            sumDiscount: function(result) {
                let sum = 0;
                if (result.date_discount && result.weekday_discount) {
                    sum = (100 - (1 - result.date_discount / 100) * (1 - result.weekday_discount / 100) * 100);
                } else if (result.date_discount) {
                    sum = result.date_discount;
                } else if (result.weekday_discount) {
                    sum = result.weekday_discount;
                }

                sum = sum.toFixed(2);

                if (sum <= 0) return;

                return this.toChineseDiscount(sum);
            },
            toChineseDiscount(value) {
                let discount = Math.round( (100 - value) * 100) / 100;

                if (discount < 10) {
                    return '0' + discount;
                }

                if (discount % 10) {
                    return discount
                }

                return discount / 10
            },
            setDiscount: function(key, value) {
                if (value) {
                    this.discount[key] = 1 - (value / 100);
                } else {
                    this.discount[key] = 1;
                }
            },
            confirmText: function() {
                return `<div><span class="confirm-box__store-name">${this.selectedStore.name}</span> - <span class="confirm-box__mall">${this.selectedStore.mall.name}</span></div>
                        <div><span class="confirm-box__address">${this.selectedStore.mall.address}</span></div>
                        <div class="confirm-box__reserve-table">
                            <table class="confirm-box__time-zone">
                            <tbody>
                                <tr>
                                    <th class="confirm-box__time-zone-header">日期</th>
                                    <th class="confirm-box__time-zone-header">時間</th>
                                    <th class="confirm-box__time-zone-header">人數</th>
                                </tr>
                                <tr>
                                    <td class="confirm-box__time-zone-row">${this.form.get('date_format')}</td>
                                    <td class="confirm-box__time-zone-row">${this.form.get('start_at')} - ${this.form.get('end_at')}</td>
                                    <td class="confirm-box__time-zone-row">${this.form.get('max_customer')}位</td>
                                </tr>
                            </tbody>
                            </table>
                        </div>`;
            },
            fetchTables: function (id) {
                this.tables = [];
                this.dates = [];
                this.times = [];
                this.max_customer = 0;
                this.progressBar.open();

                popsale.formRequest(`/popsale/api/v1/res/store/${this.selectedStore.id}/tables`,'get', null, function (response) {
                    this.progressBar.close();
                    this.tables = response.data;
                    this.showOne = false;
                    if (response.data.length === 1) {
                        this.$nextTick(function () {
                            $('#table-box.section-box').hide();
                            $('.table-item').first().click();
                        }.bind(this));
                    }
                }.bind(this));

            },
            fetchDates: function(id) {
                this.progressBar.open();

                popsale.formRequest(`/popsale/api/v1/res/store/${this.selectedStore.id}/dates?table_id=${id}`, 'get', null, function (response) {
                    this.dates = response;
                    this.progressBar.close();

                    $('#table-box.section-box.center').removeClass('center');

                    this.$nextTick(function () {
                        let oldDate = this.form.get('date');

                        let index = 0;
                        for (let i = 0; i < this.dates.length; i++) {
                            let date = this.dates[i];

                            if (oldDate === date.date) {
                                index = i;
                                break
                            }
                        }

                        if (index) {
                            $('.date-item').eq(index).click();
                        } else {
                            $('.date-item').first().click();
                        }
                    }.bind(this));
                }.bind(this));
            },
            fetchTimes: function() {
                let table_id = this.form.get('table_id');
                let date = this.form.get('date');
                let url = `/popsale/api/v1/res/store/${this.selectedStore.id}/times?table_id=${table_id}&date=${date}`;

                this.progressBar.open();
                popsale.formRequest(url, 'get', null, function (response) {
                    this.times = response;
                    this.progressBar.close();

                    this.$nextTick( function () {
                        let oldChoiceStart = this.form.get('start_at');
                        let oldChoiceEnd = this.form.get('end_at');
                        this.showMenu = false;
                        let index = 0;
                        for(let i = 0; i < this.times.length; i++) {
                            let time = this.times[i];

                            if (time.start === oldChoiceStart &&  time.end === oldChoiceEnd) {
                                index = i;
                                break;
                            }
                        }

                        if (index) {
                            $('.time-item').eq(index).click();
                        } else {
                            $('.time-item').first().click();
                        }
                    }.bind(this));
                }.bind(this));
            },
            fetchCapacity: function (callback = null) {
                let table_id = this.form.get('table_id');
                let date = this.form.get('date');
                let start_at = this.form.get('start_at');
                let end_at = this.form.get('end_at');
                let url = `/popsale/api/v1/res/store/${this.selectedStore.id}/capacity?table_id=${table_id}&date=${date}&start_at=${start_at}&end_at=${end_at}`;

                this.progressBar.open();

                popsale.formRequest(url, 'get', null, function (response) {
                    this.max_customer = response;
                    this.progressBar.close();

                    //Hidden time
                    this.times.forEach(time => {
                        let t_s = Date.parse('1990-11-18 ' + time.start);
                        let t_e = Date.parse('1990-11-18 ' + time.end);
                        let s_s = Date.parse('1990-11-18 ' + start_at);
                        let s_e = Date.parse('1990-11-18 ' + end_at);


                        time.hidden = t_s !== s_s && s_s <= t_s && t_e <= s_e;
                    });

                    if (this.max_customer.length) {
                        this.$nextTick(function () {
                            let oldChoice = this.form.get('max_customer');

                            let index = 0;
                            for(let i = 0; i < this.max_customer.length; i++) {
                                let person = this.max_customer[i];

                                if (person.number === parseInt(oldChoice) ) {
                                    index = i;
                                    break;
                                }
                            }

                            if (index) {
                                $('.person-item').eq(index).click();
                            } else {
                                $('.person-item').first().click();
                            }

                            if (callback) callback();

                        }.bind(this));
                    } else {
                        this.form.delete('max_customer');
                    }
                }.bind(this))
            },
            onStoreClick: function (event, result) {
                this.resetData();
                this.clearAllSelectedItems();

                this.selectedStore = result;

                let id = result.id;
                $(event.currentTarget).parent().children('.active').toggleClass('active');
                $(event.currentTarget).toggleClass('active');

                this.form.set('store_id', id);
                this.fetchTables(id)
            },
            onTableClick: function (event, result) {
                let id = result.id;

                this.form.set('table_id', id);
                $('#table-box').find('.active').toggleClass('active');
                $(event.currentTarget).toggleClass('active');

                this.fetchDates(id);
            },
            onDateClick: function (event, item) {
                this.form.set('date_format', item.date_format);
                this.form.set('date', item.date);
                this.setDiscount('date', item.weekday_discount);
                this.setDiscount('weekday', item.date_discount);

                this.toggleActive(event, $('#container-date'));

                this.fetchTimes();
            },
            onTimeClick: function(event, item) {
                //Reset time
                if (this.selectedTimeSlot) {
                    this.selectedTimeSlot.end_at = null;
                }

                this.selectedTimeSlot = item;
                this.form.set('start_at', item.start);
                this.form.set('end_at', item.end);

                this.setDiscount('time', item.time_discount);

                $('#time-to-stay-option')[0].MDCMenu.open = false;
                this.shownMenu = false;
                this.stay_hour = item.max_stay_hour;

                this.toggleActive(event, $('#container-time'));
                this.fetchCapacity(function () {
                    if (this.selectedTimeSlot && this.showMenu) {
                        this.onTimeArrowClick(event)
                    }

                    this.showMenu = true;
                }.bind(this));
            },
            onTimeArrowClick: function(event) {
                event.preventDefault();
                event.stopPropagation();
                let menu = $('#time-to-stay-option')[0];

                if (this.stay_hour > 1 && !menu.MDCMenu.open) {
                    this.shownMenu = true;
                    menu.MDCMenu.open = true;
                } else {
                    this.shownMenu = false;
                    menu.MDCMenu.open = false;
                }
            },
            onStayTimeClick: function(event, addHour) {
                if (addHour) {
                    let data = this.form.get('start_at').split(":");
                    let date = new Date(2046, 8, 24, data[0], data[1]);
                    date.setTime(date.getTime() + (addHour * 60 * 60 * 1000) - (60 * 1000));
                    let date_str = `${date.getHours()}:${date.getMinutes()}`;

                    this.form.set('end_at', date_str);
                    this.selectedTimeSlot.end_at = date_str;

                    this.fetchCapacity();
                }
            },
            onPersonClick: function(event, item) {
                if (item && item.hasOwnProperty('number')) {
                    this.form.set('max_customer', item.number);
                    this.setDiscount('person', item.discount);

                    this.toggleActive(event, $('#container-customer'));
                }
            },
            toggleActive: function(event, container) {
                let item = $(event.currentTarget);
                item.parent().children('.active').toggleClass('active');
                item.toggleClass('active');

                this.scrollItemToCenter(container, $(event.currentTarget));

                if (this.formValidator()) {
                    this.showSubmit = true;
                }
            },
            clearAllSelectedItems: function() {
                $('#res-dialog').find('.active').toggleClass('active');
            },
            scrollTo: function (selector) {
                $(selector)[0].scrollIntoView();
            },
            scrollItemToCenter: function(scroll, item) {
                let contentWidth = scroll.width();
                let scrollWidth = scroll[0].scrollWidth;
                let scrollLeft = scroll.scrollLeft();
                let itemLeft = item.offset().left;
                let itemWidth = item.width();
                
                let offset = scrollLeft + ((itemLeft - 45) + (itemWidth / 2) - (contentWidth /2));

                scroll.animate({
                    scrollLeft: offset
                }, 500);
            },
            close: function() {
                $('#res-dialog').hide();
                this.resetData();

            },
            resetData: function() {
                this.tables = [];
                this.dates = [];
                this.times = [];
                this.max_customer = 0;
                this.selectedStore = null;
                this.discount.reset();
                this.showOne = true;
                this.showSubmit = false;
                this.form = new FormData();

                if (this.stores.length === 1) {
                    $('.store-item').first().click();
                }

                $('#table-box.section-box').addClass('center');
            },
            submit: function () {

                if (!this.formValidator()) {
                    popsale.snackText("請選擇好相關資料");
                    return;
                }

                popsale.confirm(
                    this.confirmText(),
                    function (dialog) {
                        dialog.hide();
                        let store = this.form.get('store_id');
                        let table = this.form.get('table_id');
                        let url = `/popsale/api/v1/res/store/${store}/table/${table}/reserve`;

                        this.clearAllSelectedItems();

                        popsale.formRequest(url,'post', this.form, function () {
                            $('#res-dialog.dialog').children('.active').toggleClass('active');
                            popsale.snackText('預訂成功，系統即將轉跳到你的訂單頁面');
                            setTimeout(function () {
                                window.location.href = '/user/reservations';
                            }, 1000);
                        });

                        this.resetData();
                        this.close();

                    }.bind(this),
                    function (dialog) {
                        //this.resetData();
                        dialog.hide();
                    }.bind(this),
                );
            }
        },
        mounted() {
            this.resetData();
            this.progressBar = new window.mdc.linearProgress.MDCLinearProgress($('#res-dialog-progress.mdc-linear-progress')[0]);

            $('#res-dialog').on('click', function (e) {
                if ( e.target !== e.currentTarget) {
                    return;
                }

                $('#container-store').children('.active').toggleClass('active');
                this.resetData();
            }.bind(this));

            this.$nextTick(function () {
                window.mdc.autoInit();
            }.bind(this));

            //Check Menu is open
            $('.mdc-menu-backdrop').on('click', function () {
                $('#time-to-stay-option.mdc-menu.mdc-menu-surface')[0].MDCMenu.open = false;
                this.shownMenu = false;
            }.bind(this));
        }
    }
</script>

<style lang="scss">
    $color: var(--mdc-theme-primary);
    $box-text-color: #909090;

    #res-dialog.dialog {
        z-index: 4;
    }

    #res-dialog.dialog .dialog__container {
        position: relative;
        display: flex;
        flex-direction: column;
        overflow: auto;
        -webkit-transform: translate3d(0, 0, 0);
        -webkit-backface-visibility: hidden;
        -webkit-perspective: 1000px;
        width: 100%;
        height: 100%;

        max-width: none;
        max-height: none;

        .section-box {
            background-color: white;
            padding: 5px 10px;

            span.header {
                display: inline-block;
                font-size: 1.2em;
                font-weight: 600;
                color: $box-text-color;
            }

            > * {
                margin-bottom: 10px;
            }

            &.center {
                position: absolute;
                align-self: center;
                top: calc(50% - 114px);
                max-width: calc(100% - 10px);
                padding: 0 10px;
            }

            /*@media screen and (max-width: 479px){*/
            /*    margin-bottom: 5px;*/
            /*}*/
        }

        #table-box.section-box, #store-box.section-box {
            margin-top: 40px;
        }

        #button-box.section-box {
            margin-top: auto;
        }

        .reserve-submit {
            width: 20%;
            margin-left: 10px;
            padding: 0;
            max-width: 100px;
        }

        &--horizontal-box {
            position: relative;
            display: flex;
            overflow-x: auto;
            padding-bottom: 20px;

            .store-item, .table-item, .date-item, .time-item, .person-item {
                position: relative;
                display: flex;
                flex-direction: column;
                flex: 0 0 auto;
                justify-content: center;
                align-items: center;
                border: $box-text-color 2px solid;
                border-radius: 10px;
                color: $box-text-color;
                text-align: center;
                cursor: pointer;
                overflow: hidden;
                min-width: 125px;
                min-height: 40px;

                .item__title {
                    padding: 5px 10px;
                    font-size: 1em;
                    font-weight: 500;
                }

                &:not(:first-child) {
                    margin-left: 10px;
                }

                &:hover:not(.full) {
                    border-color: $color;
                    color: $color;
                }

                &.active:not(.full) {
                    background-color: unset;
                    border-color: $color;
                    color: $color;
                }
            }

            .time-item.time-slot_arrow-right {
                flex-direction: row;
                padding-left: 12px;
            }

            &::-webkit-scrollbar-track-piece {
                background-color: $box-text-color;
                border-color: white;
                border-width: 4px 0 4px 0;
                border-style: solid;
            }

            &::-webkit-scrollbar {
                -webkit-appearance: none;
                border-width: 5px;
                height: 10px;
            }

            &::-webkit-scrollbar-thumb {
                background-color: white;
                border-radius: 10px;
                border: 1px $box-text-color solid;
            }
        }

        .date-item > .item__title {
            padding: 5px 40px;
        }

        .close {
            position: absolute;
            top: 5px;
            right: 5px;
            width: 30px;
            height: 30px;
            outline: none;
            border: 1px lightgray solid;
            border-radius: 15px;
            color: lightgray;
            text-align: center;
            transition: all .5s ease;
            padding: 0;
        }

        .close:focus,.close:active {
            outline: none;
            opacity: 0.8;
        }
    }

    .discount {
        position: absolute;
        top: -9px;
        left: -38px;
        height: 40px;
        width: 100px;
        right: auto;
        transform: rotate(-45deg);
        background: var(--mdc-theme-accent);

        > .percentage {
            position: absolute;
            bottom: 0;
            left: 0;
            font-size: 0.9em;
            font-weight: 600;
            color: white;
            margin-left: auto;
            margin-right: auto;
            right: 0;

            &:after {
                content: "折";
            }
        }
    }

    .total-discount {
        align-self: baseline;
        padding: 5px 10px;
        overflow: hidden;
        font-weight: 400;
        font-size: 1.5em;
        color: var(--mdc-theme-accent);
        width: 100%;
        border-top: 2px $color solid;

        &:before {
            color: black;
            font-size: 0.7em;
            font-weight: 400;
            content: "總折扣: "
        }

        &:after {
            content: "折";
        }

        @media screen and (max-width: 479px) {
            margin-right: auto;
        }
    }

    .full {
        position: relative;
        pointer-events: none;
        cursor: not-allowed !important;
    }

    .full-hint {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.8);

        &:before {
            position: absolute;
            top: 20%;
            left: 30%;
            content: "已額滿";
            color: red;
            border: red 2px solid;
            border-radius: 3px;
            transform: rotate(-10deg);
            padding: 2px;
        }
    }

    .confirm-box {

        &__store-name {
            font-size: 1.1em;
            font-weight: 600;
        }

        &__mall {
            font-size: 1.1em;
            font-weight: 500;
        }

        &__address {
            font-size: 1em;
            font-weight: 500;

            &:before {
                content: '地址'
            }
        }


        &__reserve-table {
            background-color: rgb(245, 245, 245);
            padding: 10px;
            margin-top: 20px;
            margin-right: 20px;
        }


        &__time-zone {
            border:none;
            border-collapse: collapse;
            table-layout: fixed;
            width: 100%;

            &-header {
                padding: 5px 20px;
                font-size: 1.1em;
                font-weight: 600;
                border-right: 2px #747474 solid;
                text-decoration: underline;
                color: #747474;
            }

            &-row {
                text-align: center;
                border-right: 2px #747474 solid;
                color: #8c8c8c;
                padding: 5px 20px;
            }

            &-header:last-child {
                border-right: none
            }

            &-row:last-child {
                border-right: none
            }
        }

    }

    div.mdc-menu-backdrop {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, .4);
    }

    div#time-to-stay-option {
        position: absolute;
        margin: auto !important;
        transform-origin: center !important;
        top: 50% !important;
        left: 50% !important;
        transform: translate(-50%, -50%) !important;
        min-width: 80%;
    }

</style>